const corporateConfig = {
  businessName: "Apex Global Corp",
  businessCategory: "Corporate Business & Consulting",
  tagline: "Driving Growth. Delivering Excellence.",
  description:
    "Apex Global Corp is a premier corporate consulting and business solutions firm helping enterprises across finance, operations, strategy, and leadership achieve sustainable growth and market leadership.",
  mission:
    "To deliver world-class business consulting and corporate solutions that create measurable, lasting value for our clients and stakeholders.",
  vision:
    "To be the most trusted corporate advisory firm in Asia, recognized for integrity, innovation, and transformational impact.",
  logo: null,
  favicon: null,
  theme: {
    primaryColor: "#1a1a2e",
    secondaryColor: "#c9a84c",
    accentColor: "#e8d5a3",
    backgroundColor: "#ffffff",
    textColor: "#1a1a2e",
    darkBackground: "#0d0d1a",
    darkText: "#f1f5f9",
    borderRadius: "8px",
    fontFamily: "'Inter', 'Georgia', serif",
  },
  darkModeEnabled: true,
  defaultDarkMode: false,
  seo: {
    title: "Apex Global Corp | Corporate Consulting & Business Solutions",
    description:
      "Apex Global Corp delivers strategic consulting, financial advisory, operations management, and leadership development for enterprises across India and globally.",
    keywords:
      "corporate consulting, business strategy, financial advisory, management consulting, leadership development, Apex Global Corp",
    ogImage:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&q=80",
    twitterCard: "summary_large_image",
  },
  contact: {
    phone: "+91 98100 55555",
    whatsapp: "919810055555",
    email: "contact@apexglobalcorp.com",
    website: "www.apexglobalcorp.com",
    address: "14th Floor, Apex Tower, Nariman Point, Mumbai - 400021, India",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.74109995709657!3d19.08250589563531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1718000000000",
  },
  businessHours: [
    { day: "Monday – Friday", hours: "8:30 AM – 6:30 PM" },
    { day: "Saturday", hours: "10:00 AM – 2:00 PM" },
    { day: "Sunday", hours: "Closed" },
  ],
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    linkedin: "https://linkedin.com",
    youtube: "https://youtube.com",
    twitter: "https://twitter.com",
  },
  hero: {
    heading: "Strategic Consulting for the Modern Enterprise",
    subheading:
      "We partner with industry leaders to solve complex business challenges, unlock new growth opportunities, and build organizations that last.",
    ctaPrimary: { label: "Schedule a Consultation", link: "/corporate/contact" },
    ctaSecondary: { label: "Our Services", link: "/corporate/services" },
    images: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1400&q=80",
      "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=1400&q=80",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1400&q=80",
    ],
  },
  about: {
    heading: "About Apex Global Corp",
    subheading: "25 Years of Corporate Excellence",
    body: "Founded in 1999, Apex Global Corp has been at the forefront of corporate consulting for over two decades. With offices in Mumbai, Delhi, Bangalore, and Singapore, we serve 200+ enterprise clients across BFSI, manufacturing, retail, healthcare, and technology sectors. Our multidisciplinary team of 400+ consultants brings deep industry expertise and a results-first approach to every engagement.",
    highlights: [
      "400+ Senior Consultants",
      "200+ Enterprise Clients",
      "25 Years of Excellence",
      "Offices in 4 Countries",
    ],
    image:
      "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=800&q=80",
  },
  services: [
    {
      id: 1,
      icon: "FaChartLine",
      title: "Business Strategy",
      description:
        "Corporate strategy, market entry, competitive analysis, and long-term growth planning for sustainable business success.",
      image: "",
    },
    {
      id: 2,
      icon: "FaBuilding",
      title: "Financial Advisory",
      description:
        "M&A advisory, financial restructuring, valuation, fundraising, and investment strategy for enterprises and investors.",
      image: "",
    },
    {
      id: 3,
      icon: "FaChartLine",
      title: "Operations Management",
      description:
        "Process optimization, supply chain transformation, lean management, and operational efficiency programs.",
      image: "",
    },
    {
      id: 4,
      icon: "FaUserMd",
      title: "Leadership Development",
      description:
        "Executive coaching, C-suite development programs, board advisory, and organizational leadership transformation.",
      image: "",
    },
    {
      id: 5,
      icon: "FaShieldAlt",
      title: "Risk & Compliance",
      description:
        "Enterprise risk management, regulatory compliance, corporate governance frameworks, and audit readiness.",
      image: "",
    },
    {
      id: 6,
      icon: "FaMobileAlt",
      title: "Digital Transformation",
      description:
        "Technology adoption strategy, digital roadmap design, change management, and enterprise innovation programs.",
      image: "",
    },
    {
      id: 7,
      icon: "FaHandsHelping",
      title: "HR & Talent Strategy",
      description:
        "Workforce planning, talent acquisition strategy, compensation benchmarking, and culture transformation.",
      image: "",
    },
    {
      id: 8,
      icon: "FaPlane",
      title: "Global Expansion",
      description:
        "International market entry, cross-border M&A, regulatory navigation, and global operations setup.",
      image: "",
    },
  ],
  stats: [
    { value: 200, label: "Enterprise Clients", suffix: "+" },
    { value: 400, label: "Senior Consultants", suffix: "+" },
    { value: 25, label: "Years of Excellence", suffix: "+" },
    { value: 98, label: "Client Retention Rate", suffix: "%" },
  ],
  whyUs: {
    heading: "Why Choose Apex Global Corp?",
    subheading: "Where expertise meets execution",
    points: [
      {
        icon: "FaShieldAlt",
        title: "Proven Track Record",
        description:
          "25+ years of delivering measurable results for Fortune 500 companies and high-growth enterprises.",
      },
      {
        icon: "FaUserMd",
        title: "Senior-Led Engagements",
        description:
          "Every project is led by a Partner-level consultant with 15+ years of industry experience.",
      },
      {
        icon: "FaChartLine",
        title: "Results-Driven Approach",
        description:
          "We tie our success to yours — with outcome-based engagements and measurable KPIs.",
      },
      {
        icon: "FaHandsHelping",
        title: "End-to-End Support",
        description:
          "From strategy to execution, we stay with you through every phase of transformation.",
      },
    ],
  },
  gallery: [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80",
      alt: "Corporate Headquarters",
      category: "Office",
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80",
      alt: "Executive Boardroom",
      category: "Office",
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=800&q=80",
      alt: "Strategy Workshop",
      category: "Events",
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&q=80",
      alt: "Leadership Summit",
      category: "Events",
    },
    {
      id: 5,
      src: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80",
      alt: "Team Collaboration",
      category: "Team",
    },
    {
      id: 6,
      src: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80",
      alt: "Client Meeting",
      category: "Team",
    },
    {
      id: 7,
      src: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80",
      alt: "Financial Analysis",
      category: "Work",
    },
    {
      id: 8,
      src: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=800&q=80",
      alt: "Data & Analytics",
      category: "Work",
    },
  ],
  pricing: [
    {
      id: 1,
      name: "Advisory",
      price: "₹75,000",
      period: "per month",
      features: [
        "Monthly Strategy Session",
        "Market Research Reports",
        "Financial Health Review",
        "Email & Phone Support",
        "Quarterly Business Review",
      ],
      highlighted: false,
    },
    {
      id: 2,
      name: "Engagement",
      price: "₹2,50,000",
      period: "per month",
      features: [
        "Dedicated Senior Consultant",
        "Full Strategy Development",
        "Operations Audit & Roadmap",
        "Leadership Coaching (2 sessions)",
        "Weekly Progress Reviews",
        "Priority Support",
      ],
      highlighted: true,
    },
    {
      id: 3,
      name: "Enterprise",
      price: "Custom",
      period: "get a quote",
      features: [
        "Full Consulting Team",
        "End-to-End Transformation",
        "Board-Level Advisory",
        "Global Expansion Support",
        "24/7 Dedicated Support",
        "NDA & Confidentiality Agreement",
      ],
      highlighted: false,
    },
  ],
  testimonials: [
    {
      id: 1,
      name: "Suresh Kapoor",
      role: "CEO, Meridian Industries Ltd.",
      review:
        "Apex Global Corp helped us restructure our entire operations division. Within 12 months, we reduced costs by 28% and improved EBITDA margins significantly. Truly transformational.",
      rating: 5,
      avatar:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80",
    },
    {
      id: 2,
      name: "Ananya Bose",
      role: "CFO, Pinnacle Retail Group",
      review:
        "Their financial advisory team guided us through a complex ₹500 Cr fundraise. The depth of expertise and professionalism was unmatched. We couldn't have done it without them.",
      rating: 5,
      avatar:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80",
    },
    {
      id: 3,
      name: "James Whitfield",
      role: "MD, Whitfield & Partners UK",
      review:
        "We engaged Apex for our India market entry strategy. Their local expertise, regulatory knowledge, and network made our launch seamless. Exceptional consultants.",
      rating: 5,
      avatar:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&q=80",
    },
  ],
  team: [
    {
      id: 1,
      name: "Rajiv Malhotra",
      role: "Chairman & Managing Partner",
      bio: "IIM Ahmedabad alumnus, 30+ years in corporate strategy and M&A advisory across Asia and Europe.",
      image:
        "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
    {
      id: 2,
      name: "Deepa Nair",
      role: "Partner – Financial Advisory",
      bio: "Ex-McKinsey, CFA charterholder with 20+ years in investment banking and corporate finance.",
      image:
        "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
    {
      id: 3,
      name: "Karan Oberoi",
      role: "Partner – Operations & Strategy",
      bio: "Former COO of a ₹2,000 Cr manufacturing conglomerate, expert in lean and Six Sigma.",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
    {
      id: 4,
      name: "Meera Iyer",
      role: "Partner – Leadership & HR",
      bio: "Certified executive coach, former CHRO with expertise in organizational design and culture.",
      image:
        "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
  ],
  faq: [
    {
      id: 1,
      question: "What industries do you specialize in?",
      answer:
        "We have deep expertise across BFSI, manufacturing, retail & e-commerce, healthcare, real estate, and technology sectors. Our consultants bring both cross-industry perspective and domain-specific knowledge.",
    },
    {
      id: 2,
      question: "How long does a typical engagement last?",
      answer:
        "Engagements range from 3-month advisory projects to multi-year transformation programs. We tailor the scope and duration to your specific business objectives and complexity.",
    },
    {
      id: 3,
      question: "Do you work with startups or only large enterprises?",
      answer:
        "While our core focus is mid-to-large enterprises, we do work with high-growth startups preparing for Series B+ funding, IPO readiness, or rapid scaling challenges.",
    },
    {
      id: 4,
      question: "How do you ensure confidentiality?",
      answer:
        "All engagements are covered by strict NDAs. We maintain complete information barriers between client engagements and adhere to the highest standards of professional confidentiality.",
    },
    {
      id: 5,
      question: "What does your onboarding process look like?",
      answer:
        "We begin with a complimentary 2-hour discovery session to understand your challenges and goals. We then present a tailored proposal with scope, timeline, team composition, and expected outcomes.",
    },
  ],
  cta: {
    heading: "Ready to Transform Your Business?",
    subheading:
      "Schedule a complimentary consultation with one of our senior partners and discover what Apex Global Corp can do for you.",
    buttonLabel: "Book a Free Consultation",
    buttonLink: "/corporate/contact",
  },
  footer: {
    tagline: "Driving Growth. Delivering Excellence.",
    copyright: `© ${new Date().getFullYear()} Apex Global Corp. All Rights Reserved.`,
    links: [
      { label: "Home", path: "/corporate" },
      { label: "Services", path: "/corporate/services" },
      { label: "Gallery", path: "/corporate/gallery" },
      { label: "Contact", path: "/corporate/contact" },
    ],
  },
  productsLabel: "Reports & Resources",
  products: [
    { id: 1, name: "India Market Entry Report 2024", category: "Reports", price: 14999, originalPrice: 19999, image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80", description: "200-page research report on India market entry strategy, regulatory landscape, and sector opportunities.", badge: "Best Seller", inStock: true },
    { id: 2, name: "Leadership Excellence Workshop", category: "Training", price: 49999, originalPrice: null, image: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=600&q=80", description: "2-day intensive leadership workshop for C-suite and senior management teams. Up to 20 participants.", badge: "Popular", inStock: true },
    { id: 3, name: "Financial Health Audit", category: "Advisory", price: 75000, originalPrice: 100000, image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=600&q=80", description: "Comprehensive financial health assessment with actionable recommendations and a 90-day improvement roadmap.", badge: "High Impact", inStock: true },
    { id: 4, name: "ESG Strategy Toolkit", category: "Reports", price: 9999, originalPrice: null, image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80", description: "Ready-to-use ESG framework, reporting templates, and implementation guide for corporate sustainability.", badge: "New", inStock: true },
  ],
  sections: {
    hero: true,
    about: true,
    services: true,
    whyUs: true,
    stats: true,
    gallery: true,
    pricing: true,
    testimonials: true,
    team: true,
    faq: true,
    cta: true,
    contact: true,
    products: true,
    enquireMode: true,
  },
};

export default corporateConfig;
